// extracted by mini-css-extract-plugin
module.exports = {"base":"CheckboxWithLabel-module-base","checkboxRow":"CheckboxWithLabel-module-checkbox-row","text":"CheckboxWithLabel-module-text"};